import {Provider} from '@angular/core';
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from "../../../core/shared/test/data/test-harness.types";
import {CmContractComponent} from "../component/protected-components/cm-contract/cm-contract.component";
import {
    CmContractObjectsNavigationComponent
} from "../component/protected-components/cm-contract/components/cm-contract-objects-navigation/cm-contract-objects-navigation.component";
import {
    CmContractStandardNavigationComponent
} from "../component/protected-components/cm-contract/components/cm-contract-standard-navigation/cm-contract-standard-navigation.component";
import {
    CmContractDocumentUploadComponent
} from "../component/protected-components/cm-contract-document-upload/cm-contract-document-upload.component";
import {
    CmContractInlineComponent
} from "../component/protected-components/cm-contract-inline-component/cm-contract-inline-component";
import {
    CmContractNavigationDropdownComponent
} from "../component/protected-components/cm-contract-navigation-dropdown/cm-contract-navigation-dropdown.component";
import {
    CmContractNotificationTypeObjectComponent
} from "../component/protected-components/cm-contract-notification-type-object/cm-contract-notification-type-object.component";
import {
    CmCreateContractCombinedFormComponent
} from "../component/protected-components/cm-create-contract-combined-form/cm-create-contract-combined-form.component";
import {
    CmCreateInsurableObjectOthersComponent
} from "../component/protected-components/cm-create-insurable-object-others/cm-create-insurable-object-others.component";
import {
    CmCreateInsurableObjectPersonComponent
} from "../component/protected-components/cm-create-insurable-object-person/cm-create-insurable-object-person.component";
import {
    CmCreateInsurableObjectPersonRelationPersonComponent
} from "../component/protected-components/cm-create-insurable-object-person-relation-person/cm-create-insurable-object-person-relation-person.component";
import {CmPartnerComponent} from "../component/protected-components/cm-partner/cm-partner.component";
import {CmPartnerSideComponent} from "../component/protected-components/cm-partner/view/side/cm-partner-side.component";
import {CmPartnerFullComponent} from "../component/protected-components/cm-partner/view/full/cm-partner-full.component";
import {
    CmUpdateInsurableObjectComponent
} from "../component/protected-components/cm-update-insurable-object/cm-update-insurable-object.component";
import {
    CmUpdateInsurableObjectObjectComponent
} from "../component/protected-components/cm-update-insurable-object/object/cm-update-insurable-object-object/cm-update-insurable-object-object.component";
import {
    ContractPersonObjectWidgetsComponent
} from "../component/protected-components/contract-person-object-widgets/contract-person-object-widgets.component";
import {
    ContractBaseTypeComponent
} from "../component/protected-components/object-base-components/contract-base-type-component/contract-base-type.component";
import {
    CmSharedComponent
} from "../component/protected-components/object-base-components/contract-component/shared/cm-shared.component";
import {
    ContractObjectComponent
} from "../component/protected-components/object-base-components/contract-component/contract-object.component";
import {
    ContractObjectFullComponent
} from "../component/protected-components/object-base-components/contract-component/view/full/contract-object-full.component";
import {
    ContractObjectInlineComponent
} from "../component/protected-components/object-base-components/contract-component/view/inline/contract-object-inline.component";
import {
    ContractObjectMiniSideComponent
} from "../component/protected-components/object-base-components/contract-component/view/mini-side/contract-object-mini-side.component";
import {
    ContractObjectSideComponent
} from "../component/protected-components/object-base-components/contract-component/view/side/contract-object-side.component";
import {
    CmContractCombinedFormCreatePage
} from "../page/cm-contract-combined-form-create/cm-contract-combined-form-create.page";
import {
    CmStatisticsComponent
} from "../page/contract-overview-page/components/statisticsComponent/cm-statistics.component";
import {CmContractLastPage} from "../page/object/cm-contract-last/cm-contract-last.page";
import {CmConfigPage} from "../page/overview/cm-config/cm-config.page";
import {
    CmContractDashboardStatusPage
} from "../page/overview/cm-contract-dashboard-status/cm-contract-dashboard-status.page";
import {ContractHistoryPage} from "../page/overview/cm-contract-history-page/contract-history.page";
import {CmContractPage} from "../page/overview/cm-contract-page/cm-contract.page";
import {
    CmContractStatusOverviewPage
} from "../page/overview/cm-contract-status-overview/cm-contract-status-overview.page";
import {
    CmContractStatusTypeOverviewPage
} from "../page/overview/cm-contract-status-type-overview/cm-contract-status-type-overview.page";
import {ContractSearchPage} from "../page/overview/contract-search/contract-search.page";
import {ContractStructurePage} from "../page/overview/contract-structure/contract-structure.page";
import {
    CmContractWidgetComponent
} from "../component/protected-components/object-base-components/contract-component/shared/components/cm-contract-widget/cm-contract-widget.component";
import {CmKpiComponent} from "../page/contract-overview-page/components/kpiComponent/cm-kpi.component";
import {
    CmContractConsultantComponent
} from "../component/protected-components/consultant-component/cm-contract/cm-contract-consultant.component";
import {
    CmContractStandardNavigationConsultantComponent
} from "../component/protected-components/consultant-component/cm-contract/components/cm-contract-standard-navigation/cm-contract-standard-navigation-consultant.component";
import {
    CmContractObjectsNavigationConsultantComponent
} from "../component/protected-components/consultant-component/cm-contract/components/cm-contract-objects-navigation/cm-contract-objects-navigation-consultant.component";
import {
    CmContractDocumentUploadConsultantComponent
} from "../component/protected-components/consultant-component/cm-contract-document-upload/cm-contract-document-upload-consultant.component";
import {
    ContractPersonObjectWidgetConsultantComponent
} from "../component/protected-components/consultant-component/contract-person-object-widgets/contract-person-object-widget-consultant.component";
import {CmContractConsultantPage} from "../page/consultant-page/overview/cm-contract-page/cm-contract-consultant.page";


const cmModuleEntry: TestModuleDefinition = {
    key: 'cm',
    label: 'Contract (cm)',
    components: [
        {
            key: 'CmContractComponent',
            component: CmContractComponent,
             selector: 'mvs-cm-contract',
            label: 'Contract CM',
            type: 'ObjectBaseComponent',
        },
        {
            key: 'CmContractObjectsNavigationComponent',
            component: CmContractObjectsNavigationComponent,
            selector: 'cm-contract-objects-navigation',
            label: 'Contract Navigation',
            type: 'Component',
        },
        {
            key: 'CmContractStandardNavigationComponent',
            component: CmContractStandardNavigationComponent,
            selector: 'cm-contract-standard-navigation',
            label: 'Contract Standard Navigation',
            type: 'ObjectSubBaseComponent',
        },
        {
            key: 'CmContractDocumentUploadComponent',
            component: CmContractDocumentUploadComponent,
            selector: 'cm-contract-document-upload',
            label: 'Contract Document Upload',
            type: 'Component',
        },
        {
            key: 'CmContractInlineComponent',
            component: CmContractInlineComponent,
            selector: 'cm-inline-component',
            label: 'Contract Inline Component',
            type: 'Component',
        },
        {
            key: 'CmContractNavigationDropdownComponent',
            component: CmContractNavigationDropdownComponent,
            selector: 'cm-contract-navigation-contract',
            label: 'Contract Navigation Dropdown',
            type: 'Component',
        },
        {
            key: 'CmContractNotificationTypeObjectComponent',
            component: CmContractNotificationTypeObjectComponent,
            selector: 'cm-contract-notification-type-object',
            label: 'Contract Notification Type',
            type: 'ObjectBaseComponent',
        },
        {
            key: 'CmCreateContractCombinedFormComponent',
            component: CmCreateContractCombinedFormComponent,
            selector: 'cr-create-contract-combined-form',
            label: 'Customer Create Contract Combined Form',
            type: 'Component',
        },
        {
            key: 'CmCreateInsurableObjectOthersComponent',
            component: CmCreateInsurableObjectOthersComponent,
            selector: 'cm-create-insurable-object-others',
            label: 'Contract Create Insurable Object',
            type: 'Component',
        },
        {
            key: 'CmCreateInsurableObjectPersonComponent',
            component: CmCreateInsurableObjectPersonComponent,
            selector: 'cm-create-insurable-object-person',
            label: 'Contract Create Insurable Object Person',
            type: 'Component',
        },
        {
            key: 'CmCreateInsurableObjectPersonRelationPersonComponent',
            component: CmCreateInsurableObjectPersonRelationPersonComponent,
            selector: 'cm-create-insurable-object-person-relation-person',
            label: 'Contract Create Insurable Object Person Relation Person',
            type: 'Component',
        },
        {
            key: 'CmPartnerComponent',
            component: CmPartnerComponent,
            selector: 'mvs-cm-partner-component',
            label: 'Contract Partner Component',
            type: 'ObjectBaseComponent',
        },
        {
            key: 'CmPartnerSideComponent',
            component: CmPartnerSideComponent,
            selector: 'cm-partner-side',
            label: 'Contract Partner Side View',
            type: 'Component',
        },
        {
            key: 'CmPartnerFullComponent',
            component: CmPartnerFullComponent,
            selector: 'cm-partner-full',
            label: 'Contract Full Component',
            type: 'Component',
        },
        {
            key : 'CmUpdateInsurableObjectComponent',
            component: CmUpdateInsurableObjectComponent,
            selector: 'cm-update-insurable-object',
            label: 'Contract Update Insurable Object ',
            type: 'Component',
        },
        {
            key: 'CmUpdateInsurableObjectObjectComponent',
            component: CmUpdateInsurableObjectObjectComponent,
            selector: 'cm-create-new-insurable-object-object',
            label: 'Contract Update Insurable Object Object',
            type: 'ObjectBaseComponent',
        },
        {
            key: 'ContractPersonObjectWidgetsComponent',
            component: ContractPersonObjectWidgetsComponent,
            selector: 'cm-contract-person-object-widgets',
            label: 'Contract Person Object Widgets',
            type: 'Component',
        },
        {
            key: 'ContractBaseTypeComponent',
            component: ContractBaseTypeComponent,
            selector: 'contract-base-type-object-component',
            label: 'Contract Base Type Component',
            type: 'Component',
        },
        {
            key: 'CmSharedComponent',
            component: CmSharedComponent,
            selector: 'cm-shared-component',
            label: 'Contract Shared Component',
            type: 'Component',
        },
        {
            key: 'ContractObjectComponent',
            component: ContractObjectComponent,
            selector: 'cm-contract-object-component',
            label: 'Contract Object Component',
            type: 'ObjectBaseComponent',
        },
        {
            key: 'ContractObjectFullComponent',
            component: ContractObjectFullComponent,
            selector: 'cm-contract-object-full-component',
            label: 'Contract Object Full Component',
            type: 'Component',
        },
        {
            key: 'ContractObjectInlineComponent',
            component: ContractObjectInlineComponent,
            selector: 'cm-contract-object-inline-component',
            label: 'Contract Object Inline Component',
            type: 'Component',
        },
        {
            key: 'ContractObjectMiniSideComponent',
            component: ContractObjectMiniSideComponent,
            selector: 'cm-contract-object-mini-side-component',
            label: 'Contract Object Mini Side Component',
            type: 'Component',
        },
        {
            key: 'ContractObjectSideComponent',
            component: ContractObjectSideComponent,
            selector: 'cm-contract-object-side-component',
            label: 'Contract Object Side Component',
            type: 'Component',
        },
        {
            key: 'CmContractCombinedFormCreatePage',
            component: CmContractCombinedFormCreatePage,
            selector: 'cm-contract-combined-form-create',
            label: 'Contract Combined Form',
            type: 'PageComponent',
        },
        {
            key: 'CmKpiComponent',
            component: CmKpiComponent,
            selector: 'cm-kpi-component',
            label: 'Contract Kpi Base Component',
            type: 'Component',
        },
        {
            key: 'CmStatisticsComponent',
            component: CmStatisticsComponent,
            selector: 'cm-statistics-component',
            label: 'Contract Statistics Component',
            type: 'Component',
        },
        {
            key: 'CmContractLastPage',
            component: CmContractLastPage,
            selector: 'mvs-cm-contract-last',
            label: 'Contract Last',
            type: 'PageComponent',
        },
        {
            key: 'CmConfigPage',
            component: CmConfigPage,
            selector: 'mvs-cm-config',
            label: 'Contract Config Page',
            type: 'PageComponent',
        },
        {
            key: 'CmContractDashboardStatusPage',
            component: CmContractDashboardStatusPage,
            selector: 'cm-contract-dashboard-status',
            label: 'Contract Dashboard Status',
            type: 'DashboardPage',
        },
        {
            key: 'ContractHistoryPage',
            component: ContractHistoryPage,
            selector: 'contract-history-page',
            label: 'Contract History',
            type: 'PageComponent',
        },
        {
            key: 'CmContractPage',
            component: CmContractPage,
            selector: 'mvs-cm-contract-page',
            label: 'Contract Page',
            type: 'PageComponent',
        },
        {
            key: 'CmContractStatusOverviewPage',
            component: CmContractStatusOverviewPage,
            selector: 'mvs-dm-document-page',
            label: 'Contract Status Overview',
            type: 'ObjectPageComponent',
        },
        {
            key: 'CmContractStatusTypeOverviewPage',
            component: CmContractStatusTypeOverviewPage,
            selector: 'cm-contract-status',
            label: 'Contract Status Type Overview',
            type: 'ObjectPageComponent',
        },
        {
            key: 'ContractSearchPage',
            component: ContractSearchPage,
            selector: 'cm-contract-search',
            label: 'Contract Search',
            type: 'PageComponent',
        },
        {
            key: 'ContractStructurePage',
            component: ContractStructurePage,
            selector: 'mvs-cm-Contract-structure-structure-page',
            label: 'Contract Structure',
            type: 'PageComponent',
        },
        {
            key: 'CmContractWidgetComponent',
            component: CmContractWidgetComponent,
            selector: 'cm-contract-widget',
            label: 'Contract Widget',
            type: 'Component',
        },
        {
            key: 'CmContractConsultantComponent',
            component: CmContractConsultantComponent,
            selector: 'mvs-cm-contract-consultant',
            type: 'ObjectBaseComponent',
            label: 'cm contract consultant component'
        },
        {
            key: 'CmContractStandardNavigationConsultantComponent',
            component: CmContractStandardNavigationConsultantComponent,
            selector: 'cm-contract-standard-navigation-consultant',
            type: 'CmContractStandardNavigationComponent',
            label: 'cm contract standard navigation consultant component'
        },
        {
            key: 'CmContractObjectsNavigationConsultantComponent',
            component: CmContractObjectsNavigationConsultantComponent,
            selector: 'cm-contract-objects-navigation-consultant',
            type: 'CmContractObjectsNavigationComponent',
            label: 'cm contract objects navigation consultant component'
        },
        {
            key: 'CmContractDocumentUploadConsultantComponent',
            component: CmContractDocumentUploadConsultantComponent,
            selector: 'cm-contract-document-upload-consultant',
            type: 'Component',
            label: 'cm contract document upload consultant component'
        },
        {
            key: 'ContractPersonObjectWidgetConsultantComponent',
            component: ContractPersonObjectWidgetConsultantComponent,
            selector: 'cm-contract-person-object-widgets-consultant',
            type: 'Component',
            label: 'contract person object widget consultant component'
        },
        {
            key: 'CmContractConsultantPage',
            component: CmContractConsultantPage,
            selector: 'mvs-cm-contract-consultant-page',
            type: 'ObjectPageComponent',
            label: 'cm contract consultant page'
        }

    ]
};

export const CM_TEST_PROVIDERS: Provider[] = [
    { provide: TEST_MODULE_REGISTRY, useValue: cmModuleEntry, multi: true }
];